import React from "react";
import Edit from "../../../../assets/icons/edit_blue.svg";


import closeIcon from "../../../../assets/icons/close.svg";
const TemplateHeader = (props) => {
  return (
    <div className="header d-flex">
      <div className="is-size-h4">{props.documentTitle}</div>
      <div>
      <label
        className=
          "edit-icon">
        <img onClick={props.openEditModal} src={Edit} alt="Edit"/>
      </label>
     </div>

      <div className="ml-auto close" onClick={props.templateCloseHandler}>
        <img src={closeIcon} alt="close" />
      </div>
   </div>
  );
};

export default TemplateHeader;
